// extracted by mini-css-extract-plugin
export default {"container":"SN5CVGxgQLZtTahtzE9y9A==","link":"mcXL9uoYeqhdPOiYSoMf7w=="};